import { ForwardedRef, forwardRef, ReactNode, useState } from "react"
import { Popover, PopoverOrigin } from "@mui/material"

type Props<T extends HTMLElement> = {
  renderButton: (
    clickHandler: (event: React.MouseEvent<T>) => void,
    ref: ForwardedRef<HTMLButtonElement>,
    isOpen: boolean,
    tooltipProps: {},
  ) => ReactNode
  children: (close: () => void) => ReactNode
  anchorOrigin?: PopoverOrigin
  transformOrigin?: PopoverOrigin
}

export const PopoverButton = forwardRef<
  HTMLButtonElement,
  Props<HTMLButtonElement>
>(function ColorPickerButton(
  { renderButton, children, anchorOrigin, transformOrigin, ...props },
  ref,
) {
  const [anchorEl, setAnchorEl] = useState<null | HTMLElement>(null)
  const handleClick = (event: React.MouseEvent<HTMLButtonElement>) => {
    setAnchorEl(event.currentTarget)
  }
  function handleClose() {
    setAnchorEl(null)
  }
  const open = Boolean(anchorEl)
  return (
    <>
      {renderButton(handleClick, ref, open, props)}
      <Popover
        open={open}
        anchorEl={anchorEl}
        onClose={handleClose}
        anchorOrigin={anchorOrigin}
        transformOrigin={transformOrigin}
      >
        {children(() => setAnchorEl(null))}
      </Popover>
    </>
  )
})
